export const HIGHLIGHTS_CONSTS = {
  moduleName: 'epb-highlights',

  getters: {
    setup: 'setup',
  },
  actions: {
    setSetup: 'setSetup',
  },
  mutations: {
    setSetup: 'setSetup',
  },
  storage: {
    setup: 'highlights-setup',
  },
}
